// Search-result ordering for the CatalogList (Create-New-{Assessment,Resource}
// pickers). Items whose TITLE contains the query rank above items that only
// match in the description; ties are broken alphabetically by title. With an
// empty query every item "matches" the empty substring, so this degrades to a
// plain alphabetical sort (the prior behaviour) — safe to call when unsearched.
//
// Kept in its own module (no heavy imports) so it stays unit-testable in
// isolation from the CatalogList component's dependency graph. Ported 1:1 from
// the legacy fix (PR 2088, `_legacy/components/Shared/CreateNewItemModal/searchSort.js`).
export const sortBySearchRelevance = (list, rawQuery) => {
  const query = (rawQuery || '').toLowerCase().trim();
  return [...list].sort((a, b) => {
    const aTitle = String(a.title ?? '');
    const bTitle = String(b.title ?? '');
    const aTitleMatch = aTitle.toLowerCase().includes(query);
    const bTitleMatch = bTitle.toLowerCase().includes(query);
    if (aTitleMatch !== bTitleMatch) return aTitleMatch ? -1 : 1;
    return aTitle.localeCompare(bTitle);
  });
};
